import { Badge, Typography } from "@/components/atoms";
import { StripePaymentMethod } from "@/redux/apis/payment/stripe/types";

interface PaymentMethodCardProps {
  paymentMethod: StripePaymentMethod;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

export const PaymentMethodCard = ({ paymentMethod, isSelected, onSelect }: PaymentMethodCardProps) => {
  const card = paymentMethod.card;

  const cardBrandEmoji: Record<string, string> = {
    visa: "💳",
    mastercard: "💳",
    amex: "💳",
  };

  return (
    <div
      className={`cursor-pointer rounded-lg border-2 p-4 transition-all ${
        isSelected ? "bg-primary/10 border-primary" : "border-neutral-light-gray hover:border-primary/50"
      }`}
      onClick={() => onSelect(paymentMethod.paymentMethodId)}
    >
      <div className="flex items-center gap-3">
        <div className="text-2xl">{cardBrandEmoji[card.brand] || "💳"}</div>
        <div className="flex-1">
          <Typography variant="action" className="capitalize">
            {card.brand}
          </Typography>
          <Typography variant="small-regular" className="text-neutral-dark-gray">
            •••• •••• •••• {card.last4}
          </Typography>
          <Typography variant="small-regular" className="text-xs text-neutral-silver-gray">
            Expires {card.expMonth}/{card.expYear}
          </Typography>
        </div>
        {isSelected && <Badge type="primary" message="Selected" size="sm" />}
      </div>
    </div>
  );
};
